import type { MisconceptionDefinition } from '../types';
export const GELD_BTW: MisconceptionDefinition[] = [{
  id: 'geld.btw-only-tax',
  label: 'Geeft alleen BTW-bedrag i.p.v. totaalprijs',
  module: 'Geld',
  description: 'Leerling geeft alleen het BTW-bedrag terug in plaats van de totaalprijs inclusief BTW.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-subtract',
  label: 'Trekt BTW af i.p.v. op te tellen',
  module: 'Geld',
  description: 'Leerling trekt het BTW-bedrag van de prijs af in plaats van het erbij op te tellen.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-literal-cents',
  label: 'Interpreteert BTW-percentage als centen',
  module: 'Geld',
  description: 'Leerling interpreteert 21% letterlijk als €0,21 in plaats van als verhouding 0,21 × prijs.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-flat-rate',
  label: 'Behandelt BTW-percentage als vast bedrag',
  module: 'Geld',
  description: 'Leerling denkt dat 21% altijd €21 is ongeacht het bedrag (percentage als vast bedrag).',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-subtract-from-incl',
  label: 'Trekt BTW af i.p.v. te delen door 1,XX',
  module: 'Geld',
  description: 'Bij terugrekenen van inclusief naar exclusief BTW trekt de leerling het percentage van de inclusief-prijs af i.p.v. te delen door 1,21 (of 1,09).',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-add-instead',
  label: 'Telt BTW erbij i.p.v. eruit te rekenen',
  module: 'Geld',
  description: 'Leerling telt BTW erbij op terwijl er teruggerekend moet worden naar exclusief-prijs.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-subtract-flat',
  label: 'Trekt percentagegetal af als vast bedrag',
  module: 'Geld',
  description: 'Leerling trekt €21 (of €9) als vast bedrag af bij BTW-aftrek i.p.v. 21% (of 9%) van het bedrag.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-confuse-remainder',
  label: 'Verwart BTW-bedrag met prijs-na-aftrek',
  module: 'Geld',
  description: 'Leerling geeft de prijs na BTW-aftrek terug in plaats van alleen het BTW-bedrag.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-confuse-total',
  label: 'Verwart BTW-bedrag met totaalprijs',
  module: 'Geld',
  description: 'Leerling geeft de totaalprijs inclusief BTW terug in plaats van alleen het BTW-bedrag.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-wrong-subtraction',
  label: 'Trekt willekeurig bedrag af bij BTW',
  module: 'Geld',
  description: 'Leerling trekt een willekeurig of niet-gerelateerd bedrag af bij BTW-berekening.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-double-counted',
  label: 'BTW dubbel meegerekend',
  module: 'Geld',
  description: 'Leerling telt de BTW twee keer op (bijv. eenmaal bij de prijs én nogmaals bij het totaal) waardoor het bedrag te hoog uitvalt.',
  typicalFamilies: ['GELD-BTW']
}, {
  id: 'geld.btw-round-down',
  label: 'BTW-bedrag verkeerd naar beneden afgerond',
  module: 'Geld',
  description: 'Leerling rondt het BTW-bedrag (of de eindprijs) onterecht naar beneden af in plaats van correct af te ronden op centen.',
  typicalFamilies: ['GELD-BTW']
}];